module.exports = __webpack_public_path__ + "img/knus_gallery5.4838ecd0.jpg";